import Quiz from "./quiz";
import { _ } from "@utils";

_(window).ready(() => {
  new Quiz();
});
